const WORDS = [
  "Trade Easy", "No Bull", "$400K Funding", "80/20 Split", "Free Mentorship",
  "5-Day Payouts", "Match-Trader Execution", "Zero Personal Risk",
];

export default function EditorialMarquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="py-14 border-y border-white/5 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-editorial gap-0">
        {row.map((w, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span
              className={`text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.05em] whitespace-nowrap px-6 ${
                i % 2 === 0 ? "text-white/10" : "gold-text"
              }`}
            >
              {w}
            </span>
            <span className="w-2 h-2 rotate-45 bg-[#FFD700]/50 shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
